<ps-adjustment-table
  [adjustmentReconciliatonRecord]="reconciliationList"
  [userId]="userId"
  [userName]="userName"
  [operationType]="operationType"
  [showDownloadReportButtoonInRecon]="true"
  [showBackToDashboardButton]="true"
></ps-adjustment-table>
